import React from 'react';

const CTA: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="bg-gradient-to-br from-soez-orange to-soez-orange-dark text-white py-20 px-8 text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold mb-4">
          Ready to Transform Your Organization's Communication?
        </h2>
        <p className="text-xl mb-8 opacity-95">
          Join forward-thinking enterprises who trust SoEz for secure, intelligent collaboration.
        </p>
        <button
          onClick={scrollToContact}
          className="bg-white text-soez-orange px-10 py-5 rounded-md font-semibold text-lg hover:bg-soez-blue hover:text-white transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
        >
          Schedule Your Demo Today
        </button>
      </div>
    </section>
  );
};

export default CTA;
